"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/regenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Paper = _interopRequireDefault(require("../Paper"));
var _context5 = _interopRequireDefault(require("./context"));
var _excluded = ["classNames", "children", "className", "effect", "themes", "modes", "widthNames", "handlers", "componentsStyle", "additionalStyles", "device", "useStyle", "state", "getTarget"],
  _excluded2 = ["scrollContainer"];
var defaultStyle = require("./../empty_css.js")["default"];
var _default = exports["default"] = /*#__PURE__*/_react["default"].forwardRef(function (props, _ref3) {
  var _scrollContainer;
  var themeContext = (0, _react.useContext)(_context5["default"]);
  var _props$classNames = props.classNames,
    classNames = _props$classNames === void 0 ? defaultStyle : _props$classNames,
    children = props.children,
    className = props.className,
    effect = props.effect,
    _props$themes = props.themes,
    themes = _props$themes === void 0 ? {} : _props$themes,
    _props$modes = props.modes,
    modes = _props$modes === void 0 ? {} : _props$modes,
    _props$widthNames = props.widthNames,
    widthNames = _props$widthNames === void 0 ? {
      1: 'narrow',
      320: 'narrow',
      576: 'narrow',
      768: 'narrow',
      992: 'wide',
      1200: 'wide',
      1440: 'wide'
    } : _props$widthNames,
    _props$handlers = props.handlers,
    handlers = _props$handlers === void 0 ? {} : _props$handlers,
    componentsStyle = props.componentsStyle,
    additionalStyles = props.additionalStyles,
    _props$device = props.device,
    device = _props$device === void 0 ? {} : _props$device,
    _props$useStyle = props.useStyle,
    useStyle = _props$useStyle === void 0 ? themeContext.useStyle : _props$useStyle,
    _props$state = props.state,
    state = _props$state === void 0 ? {} : _props$state,
    _props$getTarget = props.getTarget,
    getTarget = _props$getTarget === void 0 ? function () {
      return typeof window === 'undefined' ? 'node' : 'web';
    } : _props$getTarget,
    rest2 = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var _rest2$scrollContaine = rest2.scrollContainer,
    scrollContainer = _rest2$scrollContaine === void 0 ? themeContext.scrollContainer : _rest2$scrollContaine,
    rest = (0, _objectWithoutProperties2["default"])(rest2, _excluded2);
  if (!((_scrollContainer = scrollContainer) !== null && _scrollContainer !== void 0 && _scrollContainer.current) && typeof window !== 'undefined') {
    scrollContainer = {
      current: document.body
    };
  }
  if (!props.classNames) {
    if (typeof useStyle === 'function') {
      useStyle(classNames);
    }
  }
  var container = (0, _react.useRef)();
  var containerRef = (0, _react.useRef)();
  function _setTheme(value) {
    if (state.setTheme) {
      state.setTheme(value);
    }
  }
  function applyTheme(prevState, nextState, onChange) {
    var prevTheme = prevState.theme;
    var nextTheme = nextState.theme;
    if (prevTheme !== nextTheme) {
      onChange(nextState);
    }
  }
  function _setMode(value) {
    if (state.setMode) {
      state.setMode(value);
    }
  }
  function applyMode(prevState, nextState, onChange) {
    var prevMode = prevState.mode;
    var nextMode = nextState.mode;
    if (prevMode !== nextMode) {
      onChange(nextState);
    }
  }
  function _setAutoContrast(value) {
    if (state.setAutoContrast) {
      state.setAutoContrast(value);
    }
  }
  function applyAutoContrast(prevState, nextState, onChange) {
    var prevAutoContrast = prevState.autoContrast;
    var nextAutoContrast = nextState.autoContrast;
    if (prevAutoContrast !== nextAutoContrast) {
      onChange(nextState);
    }
  }
  function setWidth(value) {
    if (state.setWidth) {
      state.setWidth(value);
    }
  }
  function applyWidth(prevState, nextState, onChange) {
    var prevWidth = prevState.width;
    var nextWidth = nextState.width;
    if (prevWidth !== nextWidth) {
      onChange(nextState);
    }
  }
  function getClassName() {
    var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var theme = p.theme || state.getTheme ? state.getTheme() : null;
    var mode = p.mode || state.getMode ? state.getMode() : null;
    var themeClassName = theme && themes[theme] ? themes[theme] : classNames.theme;
    var modeClassName = theme && mode && modes[theme] ? modes[theme][mode] && classNames[modes[theme][mode]] || modes[theme][mode] || '' : mode && classNames[mode + 'Mode'] ? classNames[mode + 'Mode'] : classNames.autoMode;
    return (0, _clsx["default"])(themeClassName, modeClassName);
  }
  function createStates() {
    if (state.createStates) {
      state.createStates('SET_OCTOPWN_UI');
    }
  }
  var prevState = (0, _react.useRef)({});
  function waitForTheContainer(_x) {
    return _waitForTheContainer.apply(this, arguments);
  }
  function _waitForTheContainer() {
    _waitForTheContainer = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regenerator2["default"])().m(function _callee3(callback) {
      return (0, _regenerator2["default"])().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            _context3.n = 1;
            return new Promise(function (resolve, reject) {
              var to;
              var _int2 = setInterval(function () {
                if (container !== null && container !== void 0 && container.current) {
                  clearInterval(_int2);
                  if (to) {
                    clearTimeout(to);
                  }
                  resolve();
                }
              }, 1);
              to = setTimeout(function () {
                clearInterval(_int2);
                clearTimeout(to);
                reject();
              }, 1000);
            });
          case 1:
            callback();
          case 2:
            return _context3.a(2);
        }
      }, _callee3);
    }));
    return _waitForTheContainer.apply(this, arguments);
  }
  function initStates() {
    createStates();
    var isMobile = device.type === 'mobile' || device.type === 'tablet' || device.type === 'wearable';
    var initialWidth = isMobile ? getTarget() === 'node' ? 375 : window.innerWidth : undefined;
    function findBreakPointName(width) {
      if (!width) {
        return widthNames[Object.keys(widthNames)[0]];
      }
      var breakPointsNumber = Object.keys(widthNames);
      var foundBreakPoint = null;
      breakPointsNumber.sort(function (a, b) {
        if (isNaN(Number(a)) || isNaN(Number(a))) {
          return 0;
        }
        if (Number(a) > Number(b)) {
          return 1;
        }
        if (Number(a) < Number(b)) {
          return -1;
        }
        return 0;
      });
      breakPointsNumber.forEach(function (breakPoint) {
        if (!isNaN(Number(breakPoint)) && width >= Number(breakPoint)) {
          foundBreakPoint = breakPoint;
        }
      });
      if (foundBreakPoint !== null) {
        return widthNames[foundBreakPoint];
      }
      return widthNames[Object.keys(widthNames)[0]];
    }
    prevState.current = (state.getState ? state.getState() : {}) || {};
    var theme = (state.getTheme ? state.getTheme() : 'octopwn') || 'octopwn';
    var mode = (state.getMode ? state.getMode() : 'dark') || 'dark';
    var autoContrast = (state.getAutoContrast ? state.getAutoContrast() : false) || false;
    var width = (state.getWidth ? state.getWidth() : findBreakPointName(initialWidth)) || findBreakPointName(initialWidth);
    var nextState = {
      theme: theme,
      mode: mode,
      autoContrast: autoContrast,
      width: width
    };
    applyTheme(prevState.current, nextState, function (nextState) {
      _setTheme(nextState.theme);
      prevState.current = (state.getState ? state.getState() : {}) || {};
      if (container !== null && container !== void 0 && container.current) {
        if (containerRef.current) {
          containerRef.current.actions.setClassName(getClassName(nextState));
        }
        container.current.setAttribute('theme', nextState.theme);
      }
      if (handlers['changeTheme']) {
        handlers['changeTheme']({
          value: nextState.theme,
          name: 'theme'
        }, nextState);
      }
    });
    applyMode(prevState.current, nextState, function (nextState) {
      _setMode(nextState.mode);
      prevState.current = (state.getState ? state.getState() : {}) || {};
      if (container !== null && container !== void 0 && container.current) {
        if (containerRef.current) {
          containerRef.current.actions.setClassName(getClassName(nextState));
        }
        container.current.setAttribute('mode', nextState.mode);
      }
      if (handlers['changeMode']) {
        handlers['changeMode']({
          value: nextState.mode,
          name: 'mode'
        }, nextState);
      }
    });
    applyAutoContrast(prevState.current, nextState, function (nextState) {
      _setAutoContrast(nextState.autoContrast);
      prevState.current = (state.getState ? state.getState() : {}) || {};
      if (container !== null && container !== void 0 && container.current) {
        if (nextState.autoContrast) {
          container.current.setAttribute('globalAutoContrast', '');
        } else {
          container.current.removeAttribute('globalAutoContrast');
        }
      }
      if (handlers['changeAutoContrast']) {
        handlers['changeAutoContrast']({
          value: nextState.autoContrast,
          name: 'autoContrast'
        }, nextState);
      }
    });
    applyWidth(prevState.current, nextState, function (nextState) {
      setWidth(nextState.width);
      prevState.current = (state.getState ? state.getState() : {}) || {};
      if (container !== null && container !== void 0 && container.current) {
        container.current.setAttribute('width', nextState.width);
      }
      if (handlers['changeWidth']) {
        handlers['changeWidth']({
          value: nextState.width,
          name: 'width'
        }, nextState);
      }
    });
    if (container !== null && container !== void 0 && container.current) {
      container.current.setAttribute('client', '');
      try {
        document.querySelector('body:has(div)');
      } catch (e) {
        container.current.setAttribute('no-has', '');
      }
    }
  }
  function disableTransition() {
    if (container.current) {
      var _container$current$cl;
      (_container$current$cl = container.current.classList).add.apply(_container$current$cl, (0, _toConsumableArray2["default"])(classNames.disableTransition.split(' ').filter(function (t) {
        return t;
      })));
    }
  }
  function enableTransition() {
    return _enableTransition.apply(this, arguments);
  }
  function _enableTransition() {
    _enableTransition = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regenerator2["default"])().m(function _callee4() {
      var _container$current$cl2;
      return (0, _regenerator2["default"])().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            if (!container.current) {
              _context4.n = 2;
              break;
            }
            _context4.n = 1;
            return new Promise(function (resolve) {
              return setTimeout(resolve, 300);
            });
          case 1:
            (_container$current$cl2 = container.current.classList).remove.apply(_container$current$cl2, (0, _toConsumableArray2["default"])(classNames.disableTransition.split(' ').filter(function (t) {
              return t;
            })));
          case 2:
            return _context4.a(2);
        }
      }, _callee4);
    }));
    return _enableTransition.apply(this, arguments);
  }
  function subscribe() {
    createStates();
    prevState.current = (state.getState ? state.getState() : {}) || {};
    if (state.subscribe) {
      return state.subscribe(function (_ref) {
        var type = _ref.type,
          payload = _ref.payload;
        if (type === 'SET_OCTOPWN_UI' && payload.name === 'theme') {
          var nextState = (state.getState ? state.getState() : {}) || {};
          applyTheme(prevState.current, nextState, function (nextState) {
            prevState.current = (state.getState ? state.getState() : {}) || {};
            if (container !== null && container !== void 0 && container.current) {
              if (containerRef.current) {
                containerRef.current.actions.setClassName(getClassName(nextState) + ' ' + classNames.disableTransition);
              } else {
                disableTransition();
              }
              container.current.setAttribute('theme', nextState.theme);
              enableTransition();
            } else {
              waitForTheContainer(function () {
                if (containerRef.current) {
                  containerRef.current.actions.setClassName(getClassName(nextState) + ' ' + classNames.disableTransition);
                } else {
                  disableTransition();
                }
                container.current.setAttribute('theme', nextState.theme);
                enableTransition();
              });
            }
            if (handlers['changeTheme']) {
              handlers['changeTheme'](payload, nextState);
            }
          });
        }
        if (type === 'SET_OCTOPWN_UI' && payload.name === 'mode') {
          var _nextState = (state.getState ? state.getState() : {}) || {};
          applyMode(prevState.current, _nextState, function (nextState) {
            prevState.current = (state.getState ? state.getState() : {}) || {};
            if (container !== null && container !== void 0 && container.current) {
              if (containerRef.current) {
                containerRef.current.actions.setClassName(getClassName(nextState) + ' ' + classNames.disableTransition);
              } else {
                disableTransition();
              }
              container.current.setAttribute('mode', nextState.mode);
              enableTransition();
            } else {
              waitForTheContainer(function () {
                if (containerRef.current) {
                  containerRef.current.actions.setClassName(getClassName(nextState) + ' ' + classNames.disableTransition);
                } else {
                  disableTransition();
                }
                container.current.setAttribute('mode', nextState.mode);
                enableTransition();
              });
            }
            if (handlers['changeMode']) {
              handlers['changeMode'](payload, nextState);
            }
          });
        }
        if (type === 'SET_OCTOPWN_UI' && payload.name === 'autoContrast') {
          var _nextState2 = (state.getState ? state.getState() : {}) || {};
          applyAutoContrast(prevState.current, _nextState2, function (nextState) {
            prevState.current = (state.getState ? state.getState() : {}) || {};
            if (container !== null && container !== void 0 && container.current) {
              disableTransition();
              if (nextState.autoContrast) {
                container.current.setAttribute('globalAutoContrast', '');
              } else {
                container.current.removeAttribute('globalAutoContrast');
              }
              enableTransition();
            } else {
              waitForTheContainer(function () {
                disableTransition();
                if (nextState.autoContrast) {
                  container.current.setAttribute('globalAutoContrast', '');
                } else {
                  container.current.removeAttribute('globalAutoContrast');
                }
                enableTransition();
              });
            }
            if (handlers['changeAutoContrast']) {
              handlers['changeAutoContrast'](payload, nextState);
            }
          });
        }
        if (type === 'SET_OCTOPWN_UI' && payload.name === 'width') {
          var _nextState3 = (state.getState ? state.getState() : {}) || {};
          applyWidth(prevState.current, _nextState3, function (nextState) {
            prevState.current = (state.getState ? state.getState() : {}) || {};
            if (container !== null && container !== void 0 && container.current) {
              disableTransition();
              container.current.setAttribute('width', nextState.width);
              enableTransition();
            } else {
              waitForTheContainer(function () {
                disableTransition();
                container.current.setAttribute('width', nextState.width);
                enableTransition();
              });
            }
            if (handlers['changeWidth']) {
              handlers['changeWidth'](payload, nextState);
            }
          });
        }
      });
    }
  }
  if (getTarget() === 'web') {
    var firstRender = !(state.getAction ? state.getAction() : null);
    var unsubscribe;
    if (firstRender) {
      (0, _react.startTransition)(function () {
        initStates();
        unsubscribe = subscribe();
      });
    }
    (0, _react.useLayoutEffect)(function () {
      if (unsubscribe) {
        unsubscribe();
        unsubscribe = null;
      }
      return subscribe();
    }, []);
  } else {
    initStates();
  }
  (0, _react.useEffect)(function () {
    function onScroll(e) {
      if (handlers.onScroll) {
        handlers.onScroll(e);
      }
    }
    function addScrollListeners() {
      var _scrollContainer2;
      if ((_scrollContainer2 = scrollContainer) !== null && _scrollContainer2 !== void 0 && _scrollContainer2.current) {
        if (scrollContainer.current === document.body) {
          document.addEventListener('scroll', onScroll);
        } else {
          scrollContainer.current.addEventListener('scroll', onScroll);
        }
        return function removeEventListener() {
          var _scrollContainer3;
          if ((_scrollContainer3 = scrollContainer) !== null && _scrollContainer3 !== void 0 && _scrollContainer3.current) {
            if (scrollContainer.current === document.body) {
              document.removeEventListener('scroll', onScroll);
            } else {
              scrollContainer.current.removeEventListener('scroll', onScroll);
            }
          }
        };
      }
    }
    return addScrollListeners();
  });
  (0, _react.useEffect)(function () {
    function getMaxScrollY() {
      var _scrollContainer4;
      if ((_scrollContainer4 = scrollContainer) !== null && _scrollContainer4 !== void 0 && _scrollContainer4.current) {
        if (scrollContainer.current === document.body) {
          return document.body.scrollHeight - window.innerHeight;
        } else {
          return scrollContainer.current.scrollHeight - scrollContainer.current.clientTop;
        }
      }
      return 0;
    }
    if (effect) {
      effect({
        actions: {
          setTheme: function setTheme(value) {
            _setTheme(value);
          },
          setMode: function setMode(value) {
            _setMode(value);
          },
          setAutoContrast: function setAutoContrast(value) {
            _setAutoContrast(value);
          },
          getMaxScrollY: getMaxScrollY,
          setScrollTop: function () {
            var _setScrollTop = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regenerator2["default"])().m(function _callee(value, smooth) {
              var _scrollContainer5;
              var maxScrollY;
              return (0, _regenerator2["default"])().w(function (_context) {
                while (1) switch (_context.n) {
                  case 0:
                    if (!((_scrollContainer5 = scrollContainer) !== null && _scrollContainer5 !== void 0 && _scrollContainer5.current && value >= 0)) {
                      _context.n = 2;
                      break;
                    }
                    maxScrollY = getMaxScrollY();
                    if (!(maxScrollY && maxScrollY < value)) {
                      _context.n = 1;
                      break;
                    }
                    _context.n = 1;
                    return new Promise(function (resolve) {
                      var to = setTimeout(finish, 1000);
                      var _int = setInterval(function () {
                        if (getMaxScrollY() >= value) {
                          finish();
                        }
                      }, 1);
                      function finish() {
                        if (to) {
                          clearTimeout(to);
                        }
                        if (_int) {
                          clearInterval(_int);
                        }
                        resolve();
                      }
                    });
                  case 1:
                    maxScrollY = getMaxScrollY();
                    value = maxScrollY && maxScrollY < value ? maxScrollY : value;
                    if (scrollContainer.current === document.body) {
                      if (smooth) {
                        window.scrollTo({
                          top: value,
                          left: 0,
                          behavior: 'smooth'
                        });
                      } else {
                        window.scrollTo(0, value);
                      }
                    } else {
                      scrollContainer.current.scrollTop = value;
                    }
                  case 2:
                    return _context.a(2);
                }
              }, _callee);
            }));
            function setScrollTop(_x2, _x3) {
              return _setScrollTop.apply(this, arguments);
            }
            return setScrollTop;
          }(),
          getScrollTop: function getScrollTop() {
            var _scrollContainer6;
            if ((_scrollContainer6 = scrollContainer) !== null && _scrollContainer6 !== void 0 && _scrollContainer6.current) {
              if (scrollContainer.current === document.body) {
                return window.scrollY;
              } else {
                return scrollContainer.current.scrollTop;
              }
            }
          },
          getScrollElement: function getScrollElement() {
            var _scrollContainer7;
            return (_scrollContainer7 = scrollContainer) === null || _scrollContainer7 === void 0 ? void 0 : _scrollContainer7.current;
          }
        }
      });
    }
    return function () {
      if (effect) {
        effect({
          actions: {
            setTheme: function setTheme() {
              return null;
            },
            setMode: function setMode() {
              return null;
            },
            setAutoContrast: function setAutoContrast() {
              return null;
            },
            getMaxScrollY: function getMaxScrollY() {
              return null;
            },
            setScrollTop: function () {
              var _setScrollTop2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regenerator2["default"])().m(function _callee2() {
                return (0, _regenerator2["default"])().w(function (_context2) {
                  while (1) switch (_context2.n) {
                    case 0:
                      return _context2.a(2, null);
                  }
                }, _callee2);
              }));
              function setScrollTop() {
                return _setScrollTop2.apply(this, arguments);
              }
              return setScrollTop;
            }(),
            getScrollTop: function getScrollTop() {
              return null;
            },
            getScrollElement: function getScrollElement() {
              return null;
            }
          }
        });
      }
    };
  });
  return /*#__PURE__*/_react["default"].createElement(_context5["default"].Provider, {
    value: {
      componentsStyle: componentsStyle,
      additionalStyles: additionalStyles,
      rootContainer: container,
      scrollContainer: scrollContainer,
      useStyle: useStyle,
      target: getTarget()
    }
  }, /*#__PURE__*/_react["default"].createElement(_Paper["default"], Object.assign({
    onWidthChange: function onWidthChange(width) {
      var widthName = width && widthNames[width] ? widthNames[width] : width;
      setWidth(widthName);
    },
    defaultBreakPoints: true,
    elevation: null
  }, rest, {
    ref: function ref(e) {
      container.current = e;
      if (_ref3) {
        if (typeof _ref3 === 'function') {
          _ref3(e);
        } else if (_ref3 && typeof _ref3 === 'object') {
          _ref3.current = e;
        }
      }
    },
    effect: function effect(_ref2) {
      var actions = _ref2.actions;
      return containerRef.current = {
        actions: actions
      };
    },
    defaultClassName: (0, _clsx["default"])(classNames.root, className),
    className: getClassName(),
    theme: state.getTheme ? state.getTheme() : null,
    mode: state.getMode ? state.getMode() : null
  }, (state.getAutoContrast ? state.getAutoContrast() : false) || false ? {
    autoContrast: ''
  } : {}, {
    width: state.getWidth ? state.getWidth() : null
  }), children));
});